import type { Services } from './types';
import { createLocalServices } from './local/localServices';
import { createCloudflareServices } from './cloudflare/cloudflareServices';

// The one place that decides where data lives. Today: localStorage. To go
// online, set VITE_API_BASE_URL (a Cloudflare Worker URL) and this returns the
// Cloudflare-backed services instead — no other file changes.
export function createServices(): Services {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  if (baseUrl) return createCloudflareServices({ baseUrl });
  return createLocalServices();
}

export type * from './types';
